<template>
  <div
    :class="[
      'flex',
      'flex-col',
      'h-full',
      card.Style === 'halebop'
        ? `
            inset-2 
            [background-image:url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_circle_glass_turquoise_4.png?width=100&format=webp'),url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_macarone_plastic_yellow_3.png?width=100&format=webp'),url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_plectrum_silicon_green_4.png?width=100&format=webp')] 
            dark:[background-image:url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_circle_glass_green_4.png?width=100&format=webp'),url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_macarone_glass_green_3.png?width=100&format=webp'),url('https://d2qcocilg0cqfe.cloudfront.net/images/sitewide/halebop_plankton_plectrum_silicon_turquoise_4.png?width=100&format=webp')] 
            bg-no-repeat
            [background-position:top_8px_left_16px,bottom_40%_right_-20px,bottom_32px_left_-12px]
`
        : '',
    ]"
  >
    <div class="px-16 flex flex-col justify-center m-auto">
      <div
        v-if="card.Title"
        class="flex flex-row justify-center text-center py-15"
      >
        <BoxedText
          element="p"
          box-color-class="bg-surface-action-1"
          text-color-class="text-text-on-highlight"
          text-class="heading-xs"
        >
          <span
            class="leading-[200%]"
            v-html="markup_markdownLikeTextToHtmlString(card.Title)"
          />
        </BoxedText>
      </div>

      <div v-if="card.SubText" class="flex flex-row justify-center text-center">
        <p v-html="markup_markdownLikeTextToHtmlString(card.SubText)"></p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';
import type { SeasonDealMarkupCard } from '~/models/seasonaldeals/SeasonalDealMarkupCard.model';

interface Props {
  card: SeasonDealMarkupCard;
}

defineProps<Props>();
</script>
